export const POLITICAL_PACKAGES = [
  {
    id: "booth-starter",
    name: "Booth Starter",
    hindi: "नगर पालिका / पंचायत",
    level: "Ward · Nagar Palika · Panchayat",
    price: "₹1.5L",
    unit: "per month",
    duration: "Min. 2 months",
    highlight: false,
    features: [
      "Candidate social media (FB, Insta, WhatsApp)",
      "15 reels + 30 creatives per month",
      "Ward-wise voter list & booth sheets",
      "2 nukkad sabha videos per week",
      "Hoarding & pamphlet design",
      "Weekly strategy call",
    ],
  },
  {
    id: "vidhan-sabha-pro",
    name: "Vidhan Sabha Pro",
    hindi: "विधानसभा",
    level: "Assembly constituency",
    price: "₹6L",
    unit: "per month",
    duration: "90-day campaign",
    highlight: true,
    features: [
      "Dedicated 6-person war room in constituency",
      "Constituency survey + booth-level mapping",
      "Daily reels, bytes & WhatsApp network (500+ groups)",
      "Campaign film + 3 chunavi geet",
      "PR desk — regional press & TV",
      "Rally, roadshow & LED van management",
      "Rapid response & opposition tracking",
      "Polling-day turnout operation",
    ],
  },
  {
    id: "lok-sabha-command",
    name: "Lok Sabha Command",
    hindi: "लोकसभा",
    level: "Parliamentary constituency",
    price: "₹18L",
    unit: "per month",
    duration: "120-day campaign",
    highlight: false,
    features: [
      "Everything in Vidhan Sabha Pro × 8 segments",
      "Central war room + 8 segment teams",
      "Data & analytics cell with daily dashboards",
      "Influencer & creator network",
      "Documentary-grade campaign films",
      "Crisis communication desk 24×7",
      "Founder-led strategy with Anuj Tiwari",
    ],
  },
];

export const CREATIVE_PACKAGES = [
  {
    id: "reels-basic",
    name: "Reels Basic",
    hindi: "रील्स",
    level: "Leaders · Creators · Local brands",
    price: "₹25,000",
    unit: "per month",
    duration: "12 reels",
    highlight: false,
    features: ["12 vertical reels / shorts", "Hindi captions & subtitles", "Trending audio sync", "2 revisions per reel", "48-hr turnaround"],
  },
  {
    id: "reels-pro",
    name: "Reels Pro",
    hindi: "रील्स प्रो",
    level: "Daily presence",
    price: "₹60,000",
    unit: "per month",
    duration: "30 reels",
    highlight: true,
    features: ["30 reels / shorts — one every day", "Motion graphics & lower-thirds", "Thumbnail + caption copy", "Monthly shoot day in Indore", "24-hr turnaround", "Account management & posting"],
  },
  {
    id: "brand-launch",
    name: "Brand Launch",
    hindi: "ब्रांड लॉन्च",
    level: "Real estate · Education · Hospitality",
    price: "₹3.5L",
    unit: "one-time",
    duration: "6-week sprint",
    highlight: false,
    features: ["Brand identity & guidelines", "Launch film (60s) + 10 cutdowns", "Website landing page", "Performance ads setup (Meta + Google)", "Launch event coverage", "30-day post-launch content"],
  },
];

export const ADDONS = [
  { name: "Chunavi Geet (per song)", price: "₹40,000" },
  { name: "Campaign Film (3–5 min)", price: "₹1.2L" },
  { name: "Drone Rally Coverage (per day)", price: "₹25,000" },
  { name: "Constituency Survey (sample 3,000)", price: "₹2.5L" },
  { name: "IVR + Outbound Calls (per 1 lakh)", price: "₹60,000" },
  { name: "LED Van (per day, with content)", price: "₹18,000" },
];
